import { type ReactNode } from "react";
import { Link } from "react-router";
import { ArrowLeft, FileText } from "lucide-react";
import {
  Container,
  Section,
  Heading,
  Eyebrow,
} from "./ui";
import { Seo } from "../lib/head";

export function LegalPage({
  title,
  description,
  path,
  effective,
  eyebrow = "Legal",
  children,
}: {
  title: string;
  description: string;
  path: string;
  effective?: string;
  eyebrow?: string;
  children: ReactNode;
}) {
  return (
    <>
      <Seo title={`${title} — WeConsult Rx`} description={description} path={path} />
    <Section>
      <Container>
        <Link
          to="/trust"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-forest-700 hover:text-forest-900"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden />
          Trust center
        </Link>
        <div className="mt-6 flex items-start gap-4">
          <span className="hidden md:flex h-12 w-12 items-center justify-center rounded-xl bg-forest-50 text-forest-700">
            <FileText className="h-5 w-5" aria-hidden />
          </span>
          <div>
            <Eyebrow>{eyebrow}</Eyebrow>
            <Heading level={1} className="mt-2">
              {title}
            </Heading>
            {effective ? (
              <p className="mt-3 text-sm text-ink-500">
                Effective: <strong className="text-ink-700">{effective}</strong>
              </p>
            ) : null}
          </div>
        </div>
        <div className="mt-10 max-w-prose prose-legal">{children}</div>
      </Container>
    </Section>
    </>
  );
}
